import { ILoadCalendarDayArgs } from 'src/report/server/calendar/load-calendar-day';
import { ISearchLocationsArgs, ISearchLocationsResultsArgs } from '../settings/locations-modal/search.routes';
import { IValidateReceiptRouteArgs, IValidateReceiptRouteResults } from '../registration/validate-receipt.routes';
import { IFetchWeatherReportArgs, ILoadWeatherReportResponse } from '../report/server/load/load-report';
import { clientContext } from './context';
import { buildDemoWeatherReport } from './demo-report';
import { ISubmitLogsRouteArgs, ISubmitLogsRouteResults } from '../help/submit-logs.routes';
import { IEnterCodeRouteResults } from '../help/enter-code.routes';
import { nativeService } from '../native/service';

const buildUrl = (path:string):string => {
  path = String(path || '').replace(/^\/+/, '');
  return `/api/${path}`;
  // if (clientContext.isBrowser) {
  // }else{
  //   return `https://weathernerdapi.allstarapps.com/api/${path}`;
  // }
};

export const clientApi = {
  loadCalendarDay: async (args: Omit<ILoadCalendarDayArgs, 'log'>):Promise<IWeatherReportDay> => {
    const url = buildUrl(`/load-calendar-day`);
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(args),
      method: 'POST',
    }).then(x => x.json()) as IWeatherReportDay;
    return res;
  },
  loadWeatherReport: async (args: Omit<IFetchWeatherReportArgs, 'log'>):Promise<ILoadWeatherReportResponse> => {
    const res = await (async () => {
      if (clientContext.demoMode) {
        return buildDemoWeatherReport();
      }
      const url = buildUrl(`/load-report`);
      return await fetch(url, {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(args),
        method: 'POST',
      }).then(x => x.json()) as ILoadWeatherReportResponse;
    })();
    if (!res) throw new Error(`Client api returned empty response.`);
    if (res.error) throw new Error(res.error);
    return res;
  },
  searchLocations: async (args: ISearchLocationsArgs):Promise<ISearchLocationsResultsArgs> => {
    const url = buildUrl(`/search-locations`);
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(args),
      method: 'POST',
    }).then(x => x.json()) as ISearchLocationsResultsArgs;
    return res;
  },
  validateReceipt: async (args: IValidateReceiptRouteArgs):Promise<IValidateReceiptRouteResults> => {
    if (clientContext.demoMode) {
      return { status: { ok: true, statusMs: Date.now(), expiresOnMs: Date.now() + (1000*60*60) } };
    }
    const url = buildUrl(`/validate-receipt`);
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(args),
      method: 'POST',
    });

    if (!res.ok && res.status >= 400) {
      throw String(res.text());
    }

    return res.json();
  },
  async submitDebugLogs(args: ISubmitLogsRouteArgs):Promise<void> {
    const url = buildUrl(`/submit-debug-logs`);
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(args),
      method: 'POST',
    }).then(x => x.json()) as ISubmitLogsRouteResults;
  },
  async enterCode(code: string):Promise<IEnterCodeRouteResults> {
    const url = buildUrl(`/enter-code`);
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: String(code || '').trim() }),
      method: 'POST',
    }).then(x => x.json()) as IEnterCodeRouteResults;
    return res;
  },
  hit(event: string, context: any = {}):void {
    void (async () => {
      try {
        if (clientContext.isLocal) return;
        context.deviceId = clientContext.settings.deviceId;
        context.ll = clientContext.settings?.currentLocation?.ll;
        context.loc = clientContext.settings?.currentLocation?.title;
        context.version = nativeService.context?.appStoreVersion;
        context.deviceModel = nativeService.context?.deviceModel;
        context.lang = nativeService.context?.language;
        const url = buildUrl(`/hit`);
        await fetch(url, {
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ event, context }),
          method: 'POST',
        }).then(x => x.json());
      }catch(e){
        console.log(`HIT EXCEPTION: ${event}: ${e}`);
      }
    })();
  },
};

